import React, {Fragment, useEffect, useState} from "react"
import MetaTags from "react-meta-tags"
import {Container, Card, CardBody, Nav, NavItem, NavLink} from "reactstrap"
import classnames from "classnames"
import {withRouter} from "react-router"
import {withTranslation} from "react-i18next"
import PropTypes from "prop-types"
import AddDepartement from "./AddDepartement"
import DataTableDepartement from "./DataTableDepartement"
import AffectationChefDepartement from "./AffectationChefDepartement"
import DataTableAffectation from "./DataTableAffectation"

const Departement = props => {
    const [section, setSection] = useState(1)
    const [add, setAdd] = useState(0);
    const [cloture, setCloture] = useState(0);
    useEffect(async () => {
        var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
            user.sous_menu.some(subMenu => subMenu.sous_menu === "Département")
        );
        setAdd(typeArticleSubMenu.sous_menu[0].add)
    }, [])
    const back = () => {
        setSection(1)
    }

    const renderBlock = section => {
        if (section === 1) {
            return <DataTableDepartement/>
        } else if (section === 2) {
            return <AddDepartement setSection={setSection} back={back}/>
        } else if (section === 3) {
            return <DataTableAffectation/>
        } else if (section === 4) {
            return <AffectationChefDepartement setSection={setSection} back={back}/>
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{props.t("Département")} | Cresus </title>
                </MetaTags>
                <Container fluid>
                    <div>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    style={{cursor: "pointer"}}
                                    className={classnames({
                                        active: section === 1,
                                    })}
                                    onClick={() => {
                                        setSection(1)
                                    }}
                                >
                                    {props.t("Département")}
                                </NavLink>
                            </NavItem>

                            {add === 1 ? (
                                <Fragment>
                                    {cloture != 1 ? (
                                        <NavItem>
                                            <NavLink
                                                style={{cursor: "pointer"}}
                                                className={classnames({
                                                    active: section === 2,
                                                })}
                                                onClick={() => {
                                                    setSection(2)
                                                }}
                                            >
                                                {props.t("Ajouter")} {props.t("département")}
                                            </NavLink>
                                        </NavItem>
                                    ) : (null)}
                                    <NavItem>
                                        <NavLink
                                            style={{cursor: "pointer"}}
                                            className={classnames({
                                                active: section === 3,
                                            })}
                                            onClick={() => {
                                                setSection(3)
                                            }}
                                        >
                                            {props.t("Département")} / {props.t("Chef département")}
                                        </NavLink>
                                    </NavItem>
                                    {cloture != 1 ? (
                                        <NavItem>
                                            <NavLink
                                                style={{cursor: "pointer"}}
                                                className={classnames({
                                                    active: section === 4,
                                                })}
                                                onClick={() => {
                                                    setSection(4)
                                                }}
                                            >
                                                {props.t("Affectation chef département")}
                                            </NavLink>
                                        </NavItem>
                                    ) : (null)}
                                </Fragment>
                            ) : null}
                        </Nav>
                        <Card>
                            <CardBody>{renderBlock(section)}</CardBody>
                        </Card>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(withTranslation()(Departement))
Departement.propTypes = {
    t: PropTypes.any,
}
